import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../lib/seo';

export function Breadcrumbs({ items }) {
  return (
    <nav className="kb-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {items.map((item, index) => (
          <li key={item.path}>
            {index < items.length - 1 ? (
              <Link to={item.path}>{item.name}</Link>
            ) : (
              <span aria-current="page">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function DirectAnswer({ children }) {
  return (
    <div className="direct-answer">
      <p>{children}</p>
    </div>
  );
}

export function FaqSection({ faqs }) {
  const { t } = useTranslation();
  if (!faqs?.length) return null;
  return (
    <section className="kb-section">
      <h2>{t('knowledge.page.faq')}</h2>
      {faqs.map((faq) => (
        <details key={faq.question} className="kb-faq">
          <summary>{faq.question}</summary>
          <p>{faq.answer}</p>
        </details>
      ))}
    </section>
  );
}

export function SourcesList({ sources }) {
  const { t } = useTranslation();
  if (!sources?.length) return null;
  return (
    <section className="kb-section kb-sources">
      <h2>{t('knowledge.page.sources')}</h2>
      <ul>
        {sources.map((source) => (
          <li key={source.url}>
            <a href={source.url} target="_blank" rel="noopener noreferrer">
              {source.title}
            </a>
            {source.organization ? ` — ${source.organization}` : ''}
          </li>
        ))}
      </ul>
    </section>
  );
}

export function ReviewedBy({ reviewer, reviewedAt, lang = 'en' }) {
  const { t } = useTranslation();
  if (!reviewer) return null;
  return (
    <section className="kb-reviewer">
      {reviewer.imageUrl ? (
        <img src={reviewer.imageUrl} alt={reviewer.name} />
      ) : null}
      <div>
        <p className="kb-reviewer-label">{t('knowledge.page.reviewedBy')}</p>
        <p className="kb-reviewer-name">{reviewer.name}</p>
        <p className="kb-reviewer-role">{reviewer.role}</p>
        {reviewedAt ? (
          <p className="kb-reviewer-date">
            {t('knowledge.page.lastReviewed', { date: formatDate(reviewedAt, lang) })}
          </p>
        ) : null}
      </div>
    </section>
  );
}

export function RelatedLinks({ title, items }) {
  if (!items?.length) return null;
  return (
    <section className="kb-section">
      <h2>{title}</h2>
      <ul className="kb-related">
        {items.map((item) => (
          <li key={item.path}>
            <Link to={item.path}>{item.name || item.title}</Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

export function DisclaimerNote() {
  const { t } = useTranslation();
  return <p className="kb-disclaimer">{t('knowledge.page.disclaimer')}</p>;
}
